// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DynamicContent .DynamicContent-Controls {
  z-index: 10;
  background-color: #fff;
  position: absolute;
  top: 1rem;
  right: 1rem;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 0;
  gap: 1rem;
}
.DynamicContent .DynamicContent-Controls > li {
  line-height: 1rem;
}
.DynamicContent .DynamicContent-Controls > li > button,
.DynamicContent .DynamicContent-Controls > li > .ant-dropdown-trigger {
  padding: 0 0.5rem 0 0;
}
.DynamicContent .DynamicContent-Controls > li > button > i,
.DynamicContent .DynamicContent-Controls > li > .ant-dropdown-trigger > i {
  font-size: 1.5rem;
  color: var(--bs-gray-600) !important;
  height: 1rem;
}
.DynamicContent .DynamicContent-Controls .dropdown-toggle:after {
  display: none;
}
.DynamicContent.DynamicContent-Inline {
  position: relative;
  width: 100%;
  height: 100%;
}
.DynamicContent.DynamicContent-Modal.editingTrip {
  --bs-modal-border-radius: 0px 15px 15px 15px;
}
.DynamicContent.DynamicContent-Modal.TripModal {
  width: 1160px !important;
}
.DynamicContent.DynamicContent-Modal .ant-modal-content {
  min-height: 67rem;
}
.DynamicContent.DynamicContent-Drawer .DynamicContent-Controls {
  top: 0.5rem;
  right: 0.5rem;
}
.DynamicContent.DynamicContent-Drawer .ant-drawer-header {
  display: none;
}
.DynamicContent.DynamicContent-Drawer .ant-drawer-body {
  padding: 0.5rem 1.5rem;
}
.DynamicContent .DynamicContent-Title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  gap: 0.5rem;
  padding: 0.75rem 0;
  margin-bottom: 1rem !important;
  color: var(--bs-primary);
  font-weight: 400;
  letter-spacing: 0.15rem;
  border-bottom: 1px solid var(--bs-primary);
  width: auto;
  text-transform: uppercase;
}
.DynamicContent .DynamicContent-DrawerTabs,
.DynamicContent .DynamicContent-ModalTabs {
  position: absolute;
  top: 0;
  left: -3.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  border-radius: 0.5rem 0 0 0.5rem;
  background-color: #fff;
  z-index: 999;
}
.DynamicContent .DynamicContent-DrawerTabs > button,
.DynamicContent .DynamicContent-ModalTabs > button {
  color: var(--bs-primary);
  background-color: transparent;
  border: none;
  border-right: 1px solid var(--bs-gray-300);
  padding: 1rem;
  border-radius: 0;
}
.DynamicContent .DynamicContent-DrawerTabs > button i,
.DynamicContent .DynamicContent-ModalTabs > button i {
  font-size: 1.25rem;
}
.DynamicContent .DynamicContent-DrawerTabs > button:not(:first-of-type),
.DynamicContent .DynamicContent-ModalTabs > button:not(:first-of-type) {
  border-top: 1px solid var(--bs-gray-300);
}
.DynamicContent .DynamicContent-DrawerTabs > button:first-of-type,
.DynamicContent .DynamicContent-ModalTabs > button:first-of-type {
  border-radius: var(--bs-border-radius) 0 0 0;
}
.DynamicContent .DynamicContent-DrawerTabs > button:last-of-type,
.DynamicContent .DynamicContent-ModalTabs > button:last-of-type {
  border-radius: 0 0 0 var(--bs-border-radius);
}
.DynamicContent .DynamicContent-DrawerTabs > button.isActive i,
.DynamicContent .DynamicContent-ModalTabs > button.isActive i {
  color: var(--bs-secondary);
}

.ant-modal-mask,
.ant-modal-wrap {
  z-index: 1055 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/DynamicContent/styles.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,SAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;AACM;;EAEE,qBAAA;AACR;AAAQ;;EACE,iBAAA;EACA,oCAAA;EACA,YAAA;AAGV;AACI;EACE,aAAA;AACN;AAEE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAAJ;AAII;EACE,4CAAA;AAFN;AAII;EACE,wBAAA;AAFN;AAII;EACE,iBAAA;AAFN;AAMI;EACE,WAAA;EACA,aAAA;AAJN;AAMI;EACE,aAAA;AAJN;AAMI;EACE,sBAAA;AAJN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,wBAAA;EACA,gBAAA;EACA,uBAAA;EACA,0CAAA;EACA,WAAA;EACA,yBAAA;AANJ;AASE;;EAEE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;AAPJ;AASI;;EACE,wBAAA;EACA,6BAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;AANN;AAQM;;EACE,kBAAA;AALR;AAQM;;EACE,wCAAA;AALR;AAQM;;EACE,4CAAA;AALR;AAQM;;EACE,4CAAA;AALR;AAQM;;EACE,0BAAA;AALR;;AAWA;;EAEE,wBAAA;AARF","sourcesContent":[".DynamicContent {\n  .DynamicContent-Controls {\n    z-index: 10;\n    background-color: #fff;\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: row-reverse;\n    margin-bottom: 0;\n    gap: 1rem;\n\n    > li {\n      line-height: 1rem;\n      > button,\n      > .ant-dropdown-trigger {\n        padding: 0 0.5rem 0 0;\n        > i {\n          font-size: 1.5rem;\n          color: var(--bs-gray-600) !important;\n          height: 1rem;\n        }\n      }\n    }\n    .dropdown-toggle:after {\n      display: none;\n    }\n  }\n  &.DynamicContent-Inline {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n\n  &.DynamicContent-Modal {\n    &.editingTrip {\n      --bs-modal-border-radius: 0px 15px 15px 15px;\n    }\n    &.TripModal {\n      width: 1160px !important;\n    }\n    .ant-modal-content {\n      min-height: 67rem;\n    }\n  }\n  &.DynamicContent-Drawer {\n    .DynamicContent-Controls {\n      top: 0.5rem;\n      right: 0.5rem;\n    }\n    .ant-drawer-header {\n      display: none;\n    }\n    .ant-drawer-body {\n      padding: 0.5rem 1.5rem;\n    }\n  }\n\n  .DynamicContent-Title {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    gap: 0.5rem;\n    padding: 0.75rem 0;\n    margin-bottom: 1rem !important;\n    color: var(--bs-primary);\n    font-weight: 400;\n    letter-spacing: 0.15rem;\n    border-bottom: 1px solid var(--bs-primary);\n    width: auto;\n    text-transform: uppercase;\n  }\n\n  .DynamicContent-DrawerTabs,\n  .DynamicContent-ModalTabs {\n    position: absolute;\n    top: 0;\n    left: -3.25rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: start;\n    border-radius: 0.5rem 0 0 0.5rem;\n    background-color: #fff;\n    z-index: 999;\n\n    > button {\n      color: var(--bs-primary);\n      background-color: transparent;\n      border: none;\n      border-right: 1px solid var(--bs-gray-300);\n      padding: 1rem;\n      border-radius: 0;\n\n      i {\n        font-size: 1.25rem;\n      }\n\n      &:not(:first-of-type) {\n        border-top: 1px solid var(--bs-gray-300);\n      }\n\n      &:first-of-type {\n        border-radius: var(--bs-border-radius) 0 0 0;\n      }\n\n      &:last-of-type {\n        border-radius: 0 0 0 var(--bs-border-radius);\n      }\n\n      &.isActive i {\n        color: var(--bs-secondary);\n      }\n    }\n  }\n}\n\n.ant-modal-mask,\n.ant-modal-wrap {\n  z-index: 1055 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
